import React from "react";
import PropTypes from "prop-types";

export default function Header(props) {
  const { current, all, icon } = props;
  return (
    <div className="own-it__header">
      <div className="own-it__header-left">
        {current && all && (
          <span className="question-counter">
            <span className="question-counter__current">{current}</span>/{all}
          </span>
        )}
      </div>
      <div className="own-it__header-right">
        {icon && (
          <div className="own-it__header-icon">
            <i className={`own-it-icon icon-${icon} over__icon`} />
          </div>
        )}
        <span className="own-it__title">Own It</span>
      </div>
    </div>
  );
}

Header.propTypes = {
  current: PropTypes.number,
  all: PropTypes.number,
  icon: PropTypes.string
};
